// extracted by mini-css-extract-plugin
export var header = "header-module--header--227wO";
export var headerContent = "header-module--header-content--2hV1w";
export var headerBreadcrumbs = "header-module--header-breadcrumbs--J88jC";
export var headerHeading = "header-module--header-heading--2-8Bd";
export var headerIntro = "header-module--header-intro--cfahr";
export var headerDecorationGrad1 = "header-module--header-decoration--grad1--28sNP";
export var headerLogo = "header-module--header-logo--Y7o6G";